import { STRING } from '@/plugins/sdk/fields'
import isString from 'lodash/isString'

export default {
  label: 'Ends in',
  operator: 'ends in',
  fields: [ STRING ],
  isValidValue (value) {
    return isString(value) && value.length
  }
}
